import { AxiosResponse } from 'axios';
import { IOrderRequestsResponse } from '../types/api/orderRequestsApi';
import { getAuthToken } from '../utils/commonHelper';
import { ITableRequestData } from '../types/common';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/order-review`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};

export const getOrderReviewsDataService = async ({ limit, page }: ITableRequestData): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/all`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}`;


        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getOrderReviewDetailService = async ({ id }: { id: string }): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/saved/${id}`;
        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const updateOrderRequestDetailService = async ({ id, data }: { id: string, data: any }): Promise<AxiosResponse<IOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}`;
        const response = await axiosInstance.put(url, data, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};


